const GetBrowserInfo = (): any => {

    interface BrowserInfo {
        //browser
        isBrowserChrome: boolean,
        isBrowserFirefox: boolean,
        isBrowserSafari: boolean,
        isBrowserInternetExplorer: boolean,
        isBrowserEdge: boolean,
        isBrowserUnknown: boolean,
        //os
        isOSAndroid: boolean,
        isOSiOS: boolean,
        isOSMacOS: boolean,
        isOSWindows: boolean,
        isOSLinux: boolean,
        isOSUnknown: boolean,
        //device
        isDeviceMobile: boolean,
        isDeviceTablet: boolean,
        isDeviceDesktop: boolean,
        //GET params
        urlParams: any,
    }
  
    function getBrowserInfo(): BrowserInfo {
        const userAgent = navigator.userAgent.toLowerCase();
        const platform = navigator.platform.toLowerCase();

        /* BROWSER */
        var isChrome = false
        var isFirefox = false
        var isSafari = false
        var isInternetExplorer = false
        var isEdge = false
        var isUnknown = false

        /* OS */
        var isAndroid = false
        var isiOS = false
        var isMacOS = false
        var isWindows = false
        var isLinux = false
        var isOSUnknown = false

        /* DEVICE */
        var isMobile = false
        var isTablet = false
        var isDesktop = false

        if (userAgent.match(/chrome|chromium|crios/i)) {
            isChrome = true
        } else if (userAgent.match(/firefox|fxios/i)) {
            isFirefox = true
        } else if (userAgent.match(/safari/i) && !userAgent.match(/chrome|chromium|crios/i)) {
            isSafari = true
        } else if (userAgent.match(/msie|trident/i)) {
            isInternetExplorer = true
        } else if (userAgent.match(/edg/i)) {
            isEdge = true
        } else {
            isUnknown = true
        }

        if (/android/.test(userAgent)){
            isAndroid = true
        } else if (/iphone|ipod|ipad/.test(userAgent) || (platform === 'macintel' && navigator.maxTouchPoints > 1) ){
            isiOS = true
        }else if (platform.includes('win') || userAgent.includes('windows')) {
            isWindows = true
        } else if (platform.includes('mac') || userAgent.includes('macintosh')) {
            isMacOS = true
        } else if (platform.includes('linux') || userAgent.includes('linux')) {
            isLinux = true
        } else {
            isOSUnknown = true
        }

        if (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent)) {
            isMobile = true
        } else if ((window.innerWidth > 768 && window.innerWidth < 1024) && ('ontouchstart' in window)) {
            isTablet = true
        } else {
            isDesktop = true
        }

        let searchParams = new URLSearchParams(window.location.search);

        return {
            isBrowserChrome: isChrome,
            isBrowserFirefox: isFirefox,
            isBrowserSafari: isSafari,
            isBrowserInternetExplorer: isInternetExplorer,
            isBrowserEdge: isEdge,
            isBrowserUnknown: isUnknown,

            isOSAndroid: isAndroid,
            isOSiOS: isiOS,
            isOSMacOS: isMacOS,
            isOSWindows: isWindows,
            isOSLinux: isLinux,
            isOSUnknown: isOSUnknown,
        
            isDeviceMobile: isMobile,
            isDeviceTablet: isTablet,
            isDeviceDesktop: isDesktop,

            urlParams: searchParams,
        };

    }
  
    return getBrowserInfo();
  };

export default GetBrowserInfo;